import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import HOCViewController from '../hoc/view-controller';

import PlainText from './views/plain-text';
import Avatar from './views/avatar';

import VirtualChoice from './views/virtual-choice';
import EconomicalRange from './views/economical-range';
import EconomicalMatrix from './views/economical-matrix';
import SituationalJudgement from './views/situational-judgement';

import Modal from '../shared/modal';
import ImageZoomPopup from '../shared/image-zoom-popup';
import Players from '../players';
import ModalRevealButton from '../shared/modal-reveal-button';
import EconomicalRangeTimeMultiplier from './views/economical-range-time-multiplier';
import HelpOverlay from '../shared/help-overlay';
import ModalConnectionError from '../shared/modal-connection-error';

@connect(
	state => {
		return {
			activeStep: state.step.activeStep,
			players: state.results.saveState ? state.results.saveState.players : null,
			setup: state.setup,
			avatar: state.results.saveState ? state.results.saveState.avatar : null,
			isModalClosed: state.modal.isModalClosed
		}
	}
)
export default class Sections extends Component {
	static PropTypes = {
		activeView: PropTypes.object,
		setup: PropTypes.object
	};

	componentWillMount () {
		this.state = {
			transitionKey: this.props.activeStep ? this.props.activeStep.id : 'modal',
			shouldDelay: true
		}
	}

	componentWillReceiveProps (newProps) {
		const newActiveStep = newProps.activeStep;
		const { activeStep } = this.props;

		if ((newActiveStep && activeStep) && (newActiveStep.id !== activeStep.id)) {
			this.setState({ transitionKey: newProps.activeStep.id })
		}
	}

	/**
	 * @description
	 * This method sets the data and then the view.
	 * The null is returned when the re-render is caused before the
	 * avatar gender is set to the saveState.
	 *
	 * @param type
	 * @returns {*}
	 */
	setData (type) {
		let view = null;
		let data = this.props.setup[this.props.activeStep.ref][this.props.activeStep.id];

		if (data) {
			if (this.props.avatar && (data.male || data.female)) {
				data = data[this.props.avatar.gender];
			}

			if (!data.male && !data.female) {
				view = this.setView(type, data);
			}
		}

		return view;
	}

	/**
	 * @TODO: do the update type in here to update the questions
	 * @param type
	 * @param data
	 * @returns {ReactElement}
	 */
	setView (type, data) {
		let view = null;


		switch (type) {
			case 'game-intro':
			case 'section-intro':
			case 'players-intro':
			case 'section-recap':
			case 'game-recap':
				view = PlainText;
				break;
			case 'avatar':
				view = Avatar;
				break;
			case 'virtual-choice':
				view = VirtualChoice;
				break;
			case 'update':
				view = VirtualChoice;
				break;
			case 'economical-range':
				view = EconomicalRange;
				break;
			case 'economical-matrix':
				view = EconomicalMatrix;
				break;
			case 'situational-judgement':
				view = SituationalJudgement;
				break;
			case 'economical-range-time-multiplier':
				view = EconomicalRangeTimeMultiplier;
				break;
		}

		const EnhancedView = HOCViewController(view, data);
		return <EnhancedView/>;
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { activeStep } = this.props;

		return (
			<div>
                <ModalConnectionError />
				<ImageZoomPopup/>
				<Modal transitionKey={this.state.transitionKey} help={activeStep && activeStep.help}>
					{activeStep && this.setData(activeStep.type)}
				</Modal>
				{(activeStep && activeStep.help) && <HelpOverlay content={activeStep.help} />}
				<ModalRevealButton/>
				{this.props.isModalClosed && <Players/>}
			</div>
		)
	}
}
